<template>
    <div class="bg-white p-4 my-4 rounded-lg cursor-pointer max-w-5xl shadow-sm">
        <div>
            <p>{{ title }}</p>
             <button
                 type="button"
                class="mt-2 text-indigo-600 hover:text-indigo-900"
                @click="AddItem"
            >
                {{ buttonText }}
            </button>
        </div>
        <draggable
            v-model="data"
            handle=".handle"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div
                v-for="(datum, index) in data"
                :key="`prosAndConsItem-${datum.id || datum.uuid}`"
            >
                <div class="flex flex-row">
                    <input-rich-text
                        class="w-full"
                        :name="`${name}[${index}]`"
                        v-model="datum.text"
                        :maxlength="maxlength"
                        :toolbarButtons="['rocketLink', 'italic']"
                    />
                    <span v-if="data.length > 1" class="ml=5 handle">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                        </svg>
                    </span>
                    <button type="button" @click="() => handleDelete(index)">
                        <span v-if="data.length > 1" class="text-gray-500 hover:text-gray-800">
                            <svg class="h-4 w-4 ml-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </span>
                    </button>
                </div>
                <error
                    :error="
                        errorBag[`${keyIndex}.${name}.${index}.text`]
                            ? errorBag[
                                `${keyIndex}.${name}.${index}.text`
                            ][0]
                            : null
                    "
                />
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {useFroalaStore} from "../../stores/froala";
import {v4 as uuidv4} from "uuid";

export default {
    components: { draggable },
    name: "ProsAndConsInput",
    props: {
        value: Array,
        buttonText: String,
        title: String,
        name: String,
        errorBag: {
            type: [Object, Array],
            required: false,
        },
        keyIndex: String,
        maxlength: {
            type: Number,
            required: false,
        }
    },
    data() {
        return {
            data: this.value
                ? this.value
                : [
                      '',
                  ],
            froalaStore: useFroalaStore(),
        };
    },
    updated() {
        this.$emit("input", this.data);
    },
    methods: {
        AddItem(e) {
            e.preventDefault();
            this.data.push({'text': null, 'uuid': uuidv4()});
        },
        handleDelete: function (indexOfItemToDelete) {
            this.data.splice(indexOfItemToDelete, 1);
        },
    },
    watch: {
        value(newValue) {
            if (!newValue) return;
            this.data = newValue;
        },
    },
};
</script>
